/**
 * @generated SignedSource<<3541799566d97937f31f03ae6790b707>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateTaskPortalConfigInput = {
  psaTaskId: string;
  legacyPsaTaskId?: string | null;
  clientOrgId?: string | null;
  psaMilestoneId?: string | null;
  psaProjectId?: string | null;
  legacyPsaProjectId?: string | null;
  requiresClientSignoff?: boolean | null;
  signoffApproverForecastPersonId?: number | null;
  signoffApproverPortalUserId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateTaskPortalConfigMutation$variables = {
  input: UpdateTaskPortalConfigInput;
};
export type updateTaskPortalConfigMutation$data = {
  readonly updateTaskPortalConfig: {
    readonly taskPortalConfig: {
      readonly requiresClientSignoff: boolean | null;
      readonly signoffApproverPortalUserId: string | null;
    } | null;
  } | null;
};
export type updateTaskPortalConfigMutation = {
  variables: updateTaskPortalConfigMutation$variables;
  response: updateTaskPortalConfigMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateTaskPortalConfigPayload",
    "kind": "LinkedField",
    "name": "updateTaskPortalConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TaskPortalConfig",
        "kind": "LinkedField",
        "name": "taskPortalConfig",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "requiresClientSignoff",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "signoffApproverPortalUserId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateTaskPortalConfigMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateTaskPortalConfigMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1a3d06b88ce2858815ffb77abd45cc2a",
    "id": null,
    "metadata": {},
    "name": "updateTaskPortalConfigMutation",
    "operationKind": "mutation",
    "text": "mutation updateTaskPortalConfigMutation(\n  $input: UpdateTaskPortalConfigInput!\n) {\n  updateTaskPortalConfig(input: $input) {\n    taskPortalConfig {\n      requiresClientSignoff\n      signoffApproverPortalUserId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dee51e83534ef36c0e8cf2db1d9e47eb";

export default node;
